<div class="m-3 p-2 border bg-white">
  <div>Delete "{{article.title}}"?</div>
  <div>
    <a routerLink="/admin/content/articles" class=" btn btn-outline-danger">Cancel</a>
    <a (click)="delete()" class=" btn btn-primary">Delete</a>
  </div>
</div>
